// import React, { useContext, useState, useEffect } from "react";
// import { toPng } from "html-to-image";
// // import { saveAs } from "file-saver";
// import { themeContext } from "../Context";
// import Whammy from 'react-whammy';

// const SharePopupWithVideo = ({ question, onClose }) => {
//     const theme = useContext(themeContext);
//     const darkMode = theme.state.darkMode;
//     const [isProcessing, setIsProcessing] = useState(false);
//     const [progress, setProgress] = useState(0);
//     //Background State
//     const [bgImage, setBgImage] = useState(null);
//     React.useEffect(() => {
//         document.body.style.overflow = "hidden";
//         return () => {
//             document.body.style.overflow = "auto";
//         };
//     }, []);


//     useEffect(() => {
//         let timer;
//         if (progress < 100 && isProcessing) {
//             timer = setInterval(() => {
//                 setProgress((prev) => prev + 1);
//             }, 100);
//         } else {
//             clearInterval(timer);
//         }
//         return () => clearInterval(timer);
//     }, [progress, isProcessing]);


//     //Progress working here.
//     const handleDownloadVideo = async () => {
//         setIsProcessing(true);
//         setProgress(0);

//         const element = document.getElementById(`share-question-${question.id}`);
//         if (!element) {
//             console.error("Element not found");
//             setIsProcessing(false);
//             return;
//         }

//         const { width, height } = element.getBoundingClientRect();
//         const aspectRatio = width / height;

//         const canvasWidth = 300; // Target video width
//         const canvasHeight = canvasWidth / aspectRatio; // Maintain aspect ratio

//         try {
//             // Convert DataURLs to WebP (if needed by Whammy)
//             const convertToWebP = (dataUrl) => {
//                 return new Promise((resolve) => {
//                     const img = new Image();
//                     img.src = dataUrl;
//                     img.onload = () => {
//                         const canvas = document.createElement("canvas");
//                         canvas.width = img.width;
//                         canvas.height = img.height;
//                         const ctx = canvas.getContext("2d");
//                         ctx.drawImage(img, 0, 0);
//                         resolve(canvas.toDataURL("image/webp"));
//                     };
//                 });
//             };

//             const captureIntervalFrames = async (element, interval) => {
//                 const frames = [];
//                 for (let i = 0; i <= 100; i += interval) {
//                     setProgress(i);
//                     await new Promise(resolve => setTimeout(resolve, 100)); // 1 second per interval
//                     const dataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
//                     const webP = await convertToWebP(dataUrl);
//                     frames.push(webP);
//                 }
//                 return frames;
//             };

//             // Capture frames with progress bar updating
//             const frames = await captureIntervalFrames(element, 10);

//             // Highlight the correct answer dynamically
//             const options = element.querySelectorAll("li");
//             options.forEach((optionElement) => {
//                 // const option = optionElement.textContent.trim();
//                 const option = optionElement.getAttribute('data-answer');
//                 if (option === question.correctAnswer) {
//                     optionElement.style.backgroundColor = "lightgreen";
//                     optionElement.style.color = "black";
//                 }
//             });

//             // Generate the second image (with highlighted answer)
//             const answerDataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
//             const answerWebP = await convertToWebP(answerDataUrl);

//             // Create a Whammy video instance
//             const video = new Whammy.Video(10); // 10 FPS

//             // Add frames to the video
//             frames.forEach(frame => {
//                 for (let i = 0; i < 10; i++) {
//                     video.add(frame);
//                 }
//             });

//             // Add the answer frame for the last 5 seconds
//             for (let i = 0; i < 50; i++) {
//                 video.add(answerWebP);
//             }

//             // Compile video
//             video.compile(false, (output) => {
//                 const videoBlob = new Blob([output], { type: "video/webm" });
//                 const videoUrl = URL.createObjectURL(videoBlob);

//                 const link = document.createElement("a");
//                 link.href = videoUrl;
//                 link.download = `question-${question.id}.webm`;
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);

//                 setProgress(100); // Done
//                 alert("Video downloaded successfully!");
//                 setIsProcessing(false);
//             });

//         } catch (error) {
//             console.error("Error generating video:", error);
//             setProgress(0);
//             setIsProcessing(false);
//         }
//     };




//     const [selectedOption, setSelectedOption] = useState(null);

//     const handleOptionClick = (questionId, option) => {
//         setSelectedOption(option);
//     };

//     // const getOptionStyle = (selectedOption, correctAnswer, option) => {
//     //     if (option === correctAnswer && selectedOption === option) {
//     //         return { backgroundColor: 'lightgreen', color: 'black' }; // Correctly selected
//     //     }
//     //     if (option === selectedOption && option !== correctAnswer) {
//     //         return { backgroundColor: 'lightcoral', color: 'black' }; // Incorrectly selected
//     //     }
//     //     return {}; // Default style
//     // };
//     //3
//     const getOptionStyle = (selectedOption, correctAnswer, option) => {
//         const isSelected = selectedOption === option;
//         const isCorrect = option === correctAnswer;
//         return {
//             background: "white",
//             color: "#001F3F",
//             padding: "12px 20px",
//             margin: "10px",
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             flex: "1 0 40%", // For the 2x2 grid layout
//             fontWeight: "bold",
//             fontSize: "14px",
//             // Custom "Leaf" Shape: rounded top-left and bottom-right
//             borderRadius: "0px 20px 0px 20px",
//             backgroundColor: isSelected ? (isCorrect ? "lightgreen" : "lightcoral") : "none",
//             boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
//             transition: "transform 0.2s",
//         };
//     };
//     //BG THEME IMAGE
//     const handleImageUpload = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setBgImage(URL.createObjectURL(file));
//         }
//     };

//     const blurLayerStyle = {
//         position: "absolute",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         backgroundImage: `url(${bgImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         filter: "blur(5px)", // 25% visual blur
//         transform: "scale(1.1)", // Prevents white edges from the blur
//         zIndex: -1,
//     };

//     return (
//         <>
//             {/* Overlay for modal */}
//             <div
//                 style={{
//                     position: "fixed",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "100%",
//                     background: "rgba(0, 0, 0, 0.5)",
//                     backdropFilter: "blur(5px)",
//                     zIndex: 999,
//                 }}
//             ></div>
//             <div
//                 style={{
//                     position: "fixed",
//                     top: "50%",
//                     left: "50%",
//                     transform: "translate(-50%, -50%)",
//                     zIndex: 1000,
//                     // background: darkMode ? "#222" : "white",
//                     background: darkMode ? "rgba(34, 34, 34, 0.9)" : "rgba(255, 255, 255, 0.9)",
//                     color: darkMode ? "white" : "black",
//                     padding: "20px",
//                     borderRadius: "10px",
//                     maxWidth: "90%",
//                     width: "600px",
//                     maxHeight: "90%", // Constrain modal height
//                     overflowY: "auto", // Enable vertical scrolling
//                 }}
//             >
//                 <h3>Generate and Download Video</h3>
//                 <div style={{
//                     position: "absolute",
//                     top: "-50%",
//                     left: "-50%",
//                     width: "200%",
//                     height: "200%",
//                     background: "linear-gradient(45deg, transparent 45%, rgba(255,255,255,0.3) 50%, transparent 55%)",
//                     pointerEvents: "none",
//                     zIndex: 1
//                 }}></div>

//                 <div
//                     id={`share-question-${question.id}`}
//                     style={{
//                         // background: darkMode ? "#333" : "white",
//                         // color: darkMode ? "white" : "black",
//                         // border: darkMode ? "2px solid #555" : "2px solid #000",
//                         // borderRadius: "10px",
//                         // padding: "20px",
//                         // textAlign: "center",
//                         // margin: "0 auto",
//                         //1
//                         // background: "#FFD700", // Vibrant Yellow
//                         // background: "radial-gradient(circle at 50% 0%, #FFEC8B 0%, #FFD700 50%, #E6B800 100%)",
//                         background: bgImage ? "none" : "radial-gradient(circle at 50% 0%, #FFEC8B 0%, #FFD700 50%, #E6B800 100%)",
//                         color: "#001F3F", // Deep Navy Blue for text
//                         borderRadius: "15px",
//                         padding: "40px 20px",
//                         textAlign: "center",
//                         margin: "0 auto",
//                         position: "relative",
//                         overflow: "hidden",
//                         boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
//                         // border: "4px solid #FFFFFF", // White border makes the yellow pop
//                         // boxShadow: "0 20px 50px rgba(0,0,0,0.3), inset 0 0 20px rgba(255,255,255,0.5)",
//                     }}

//                 >
//                     {/* Background Image Layer (only shows if bgImage exists) */}
//                     {bgImage && <div style={blurLayerStyle}></div>}

//                     {/* Dark Overlay to ensure text stays readable on light images */}
//                     {/* {bgImage && <div style={{
//                         position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
//                         background: "rgba(255, 215, 0, 0.3)",
//                         zIndex: 1001
//                     }}></div>} */}

//                     <div style={{
//                         marginBottom: "20px",
//                         // border: darkMode ? "1px solid #555" : "1px solid #000",
//                         border: "1px solid #bb8686",
//                         borderRadius: "10px",
//                         padding: "20px"
//                     }}>

//                         {/* <h2 style={{
//                             fontSize: "16px",
//                             fontWeight: "bold",
//                             marginBottom: "10px"
//                         }}>
//                             {question.question}
//                             <span style={{ fontSize: "16px", fontWeight: "bold" }}> {question?.exam}</span>
//                         </h2> */}
//                         <div style={{
//                             background: "rgba(255, 255, 255, 0.95)", // Clean white background
//                             padding: "15px 10px",
//                             borderRadius: "15px",
//                             marginBottom: "25px",
//                             position: "relative",
//                             zIndex: 2,
//                             // 3D Shadow to make it "float"
//                             boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
//                             border: "1px solid rgba(255, 255, 255, 0.5)",
//                         }}>
//                             <h2 style={{
//                                 fontSize: "16px",
//                                 color: "#001F3F",
//                                 margin: 0,
//                                 lineHeight: "1.4",
//                                 fontWeight: "bold"
//                             }}>
//                                 {question.question} {question?.exam}
//                             </h2>
//                         </div>
//                         <ul style={{
//                             // listStyleType: "none", 
//                             // padding: 0 
//                             display: "flex",
//                             flexWrap: "wrap",
//                             justifyContent: "center",
//                             padding: 0,
//                             listStyle: "none"
//                         }}>
//                             {question.options.map((option, index) => (
//                                 <li
//                                     key={index}
//                                     onClick={() => handleOptionClick(question.id, option)}
//                                     style={{
//                                         padding: "10px",
//                                         margin: "5px 0",
//                                         cursor: "pointer",
//                                         border: darkMode ? "1px solid #666" : "1px solid #ddd",
//                                         borderRadius: "5px",
//                                         boxShadow: "5px 5px 15px rgba(0,0,0,0.1)",
//                                         ...getOptionStyle(selectedOption, question.correctAnswer, option),
//                                     }}
//                                     data-answer={option}  // Add this data attribute
//                                 >
//                                     <span style={{
//                                         backgroundColor: "#001F3F",
//                                         color: "white",
//                                         padding: "5px 12px",
//                                         marginRight: "15px",
//                                         borderRadius: "0 10px 0 10px",
//                                         fontSize: "12px"
//                                     }}>
//                                         {String.fromCharCode(65 + index)}
//                                     </span>
//                                     <span></span>
//                                     {option}
//                                 </li>
//                             ))}
//                         </ul>
//                         {/* <span style={{ fontSize: "12px" }}>Please find the answer at the end.</span> */}
//                         <div style={{ marginTop: "10px" }}>
//                             <div style={{
//                                 width: "100%",
//                                 background: darkMode ? "#444" : "#ddd",
//                                 borderRadius: "5px",
//                                 overflow: "hidden"
//                             }}>
//                                 <div
//                                     style={{
//                                         width: `${progress}%`,
//                                         height: "10px",
//                                         background: "lightgreen",
//                                         transition: "width 0.2s ease-in-out",
//                                     }}
//                                 ></div>
//                             </div>
//                         </div>

//                     </div>
//                     {/* <footer
//                         style={{
//                             position: "relative",
//                             bottom: "10px",
//                             background: darkMode ? "#555" : "#f1f1f1",
//                             color: darkMode ? "white" : "black",
//                             padding: "5px 10px",
//                             borderRadius: "5px",
//                         }}
//                     >
//                         <p style={{ fontSize: "14px", margin: 0 }}>© 2024 SSCVIDYA.IN</p>
//                     </footer> */}
//                     <footer
//                         style={{
//                             width: "100%",
//                             background: "#001F3F", // Deep Navy Blue footer
//                             color: "white",
//                             padding: "12px 0",
//                             position: "absolute",
//                             bottom: "0",
//                             left: "0",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             boxShadow: "0 -4px 10px rgba(0,0,0,0.1)"
//                         }}
//                     >
//                         <p style={{
//                             fontSize: "12px",
//                             margin: 0,
//                             fontWeight: "700",
//                             letterSpacing: "2px",
//                             textTransform: "uppercase"
//                         }}>
//                             © 2026 SSCVIDYA.IN
//                         </p>
//                     </footer>
//                 </div>

//                 <button
//                     onClick={handleDownloadVideo}
//                     className="button"
//                     style={{ marginTop: "10px" }}
//                     disabled={isProcessing}
//                 >
//                     {isProcessing ? "Processing..." : "Download Video"}
//                 </button>
//                 <button
//                     onClick={onClose}
//                     className="button"
//                     style={{ marginTop: "10px", marginLeft: "10px" }}
//                 >
//                     Close
//                 </button>
//                 <button
//                     className="button"
//                     style={{ marginTop: "10px", marginLeft: "10px", position: "relative" }}
//                 >
//                     Upload Theme
//                     <label style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         right: 0,
//                         bottom: 0,
//                         cursor: "pointer"
//                     }}>
//                         <input
//                             type="file"
//                             accept="image/*"
//                             onChange={handleImageUpload}
//                             style={{ display: "none" }}
//                         />
//                     </label>
//                 </button>
//             </div>
//         </>
//     );
// };

// export default SharePopupWithVideo;


import React, { useContext, useState, useEffect } from "react";
import { toPng } from "html-to-image";
// import { saveAs } from "file-saver";
import { themeContext } from "../Context";
import Whammy from 'react-whammy';

const SharePopupWithVideo = ({ question, onClose }) => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    const [isProcessing, setIsProcessing] = useState(false);
    const [isExplanationView, setIsExplanationView] = useState(false);
    // --- NEW GLOBAL SWITCH STATE ---
    const [showExplanationInVideo, setShowExplanationInVideo] = useState(true);

    //State for Font Sizes
    const [questionSize, setQuestionSize] = useState(16);
    const [optionSize, setOptionSize] = useState(14);
    const [explanationSize, setExplanationSize] = useState(14);

    const [progress, setProgress] = useState(0);
    const [countdown, setCountdown] = useState(5);

    //Background State
    const [bgImage, setBgImage] = useState(null);
    React.useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    useEffect(() => {
        let timer;
        if (progress < 100 && isProcessing) {
            timer = setInterval(() => {
                setProgress((prev) => prev + 1);
            }, 100);
        } else {
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [progress, isProcessing]);
    // Reset states when processing stops



    const questionRef = React.useRef(null);
    const [dimensions, setDimensions] = React.useState({ width: 'auto', height: 'auto' });

    React.useLayoutEffect(() => {
        if (questionRef.current && !isExplanationView) {
            const { offsetWidth, offsetHeight } = questionRef.current;
            setDimensions({ width: offsetWidth, height: offsetHeight });
        }
    }, [isExplanationView, question.question]); // Re-run when view toggles or question changes

    //Progress working here.
    // const handleDownloadVideo = async () => {
    //     setIsProcessing(true);
    //     setProgress(0);

    //     const element = document.getElementById(`share-question-${question.id}`);
    //     if (!element) {
    //         console.error("Element not found");
    //         setIsProcessing(false);
    //         return;
    //     }

    //     const { width, height } = element.getBoundingClientRect();
    //     const aspectRatio = width / height;

    //     const canvasWidth = 300; // Target video width
    //     const canvasHeight = canvasWidth / aspectRatio; // Maintain aspect ratio

    //     try {
    //         // Convert DataURLs to WebP (if needed by Whammy)
    //         const convertToWebP = (dataUrl) => {
    //             return new Promise((resolve) => {
    //                 const img = new Image();
    //                 img.src = dataUrl;
    //                 img.onload = () => {
    //                     const canvas = document.createElement("canvas");
    //                     canvas.width = img.width;
    //                     canvas.height = img.height;
    //                     const ctx = canvas.getContext("2d");
    //                     ctx.drawImage(img, 0, 0);
    //                     resolve(canvas.toDataURL("image/webp"));
    //                 };
    //             });
    //         };

    //         const captureIntervalFrames = async (element, interval) => {
    //             const frames = [];
    //             for (let i = 0; i <= 100; i += interval) {
    //                 setProgress(i);
    //                 await new Promise(resolve => setTimeout(resolve, 100)); // 1 second per interval
    //                 const dataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
    //                 const webP = await convertToWebP(dataUrl);
    //                 frames.push(webP);
    //             }
    //             return frames;
    //         };
    //         // --- PHASE 1: Capture Question (10 Seconds) ---
    //         setIsExplanationView(false); // Ensure we are on Question View
    //         // Capture frames with progress bar updating
    //         const frames = await captureIntervalFrames(element, 10);

    //         // --- PHASE 2: Highlight Correct Answer (Capture 1 Frame) ---
    //         const options = element.querySelectorAll("li");
    //         options.forEach((optionElement) => {
    //             // const option = optionElement.textContent.trim();
    //             const option = optionElement.getAttribute('data-answer');
    //             if (option === question.correctAnswer) {
    //                 optionElement.style.backgroundColor = "lightgreen";
    //                 optionElement.style.color = "black";
    //             }
    //         });

    //         // Generate the second image (with highlighted answer)
    //         const answerDataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
    //         const answerWebP = await convertToWebP(answerDataUrl);

    //         // --- PHASE 3: Capture Explanation (10 Seconds) ---
    //         if (showExplanationInVideo) {
    //             setIsExplanationView(true); // Switch to Explanation View
    //         }
    //         await new Promise(r => setTimeout(r, 1000)); // Give time for explanation image to load
    //         const explanationDataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
    //         const explanationWebP = await convertToWebP(explanationDataUrl);

    //         // Create a Whammy video instance
    //         const video = new Whammy.Video(10); // 10 FPS

    //         // Add frames to the video
    //         frames.forEach(frame => {
    //             for (let i = 0; i < 10; i++) {
    //                 video.add(frame);
    //             }
    //         });

    //         // Add the answer frame for the last 5 seconds
    //         for (let i = 0; i < 30; i++) {
    //             video.add(answerWebP);
    //         }
    //         if (showExplanationInVideo) {
    //             // Add Explanation Frame (7 seconds)
    //             for (let i = 0; i < 50; i++) {
    //                 video.add(explanationWebP);
    //             }
    //         }

    //         // Compile video
    //         video.compile(false, (output) => {
    //             const videoBlob = new Blob([output], { type: "video/webm" });
    //             const videoUrl = URL.createObjectURL(videoBlob);

    //             const link = document.createElement("a");
    //             link.href = videoUrl;
    //             link.download = `question-${question.id}.webm`;
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);

    //             setProgress(100); // Done
    //             alert("Video downloaded successfully!");
    //             setIsProcessing(false);
    //         });

    //     } catch (error) {
    //         console.error("Error generating video:", error);
    //         setProgress(0);
    //         setIsProcessing(false);
    //     }
    // };
    const handleDownloadVideo = async () => {
        setIsProcessing(true);
        setProgress(0);
        setCountdown(5); // Reset countdown

        const element = document.getElementById(`share-question-${question.id}`);
        if (!element) {
            console.error("Element not found");
            setIsProcessing(false);
            return;
        }

        const { width, height } = element.getBoundingClientRect();
        const aspectRatio = width / height;

        const canvasWidth = 300; // Target video width
        const canvasHeight = canvasWidth / aspectRatio; // Maintain aspect ratio

        try {
            // Convert DataURLs to WebP (if needed by Whammy)
            const convertToWebP = (dataUrl) => {
                return new Promise((resolve) => {
                    const img = new Image();
                    img.src = dataUrl;
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        resolve(canvas.toDataURL("image/webp"));
                    };
                });
            };

            // MODIFIED: Synchronized capture function
            const captureSynchronizedFrames = async (element, interval) => {
                const frames = [];
                for (let i = 0; i <= 100; i += interval) {
                    // Calculate current countdown (5 to 0)
                    const currentCountdown = 5 - (i / 20); // i goes 0, 20, 40, 60, 80, 100

                    // Update both progress and countdown together
                    setProgress(i);
                    setCountdown(Math.ceil(currentCountdown));

                    await new Promise(resolve => setTimeout(resolve, 100)); // 100ms per interval

                    const dataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
                    const webP = await convertToWebP(dataUrl);
                    frames.push(webP);
                }
                setCountdown(null); // Hide countdown when done
                return frames;
            };

            // --- PHASE 1: Capture Question (5 Seconds Synchronized) ---
            setIsExplanationView(false);
            const frames = await captureSynchronizedFrames(element, 20);

            // --- PHASE 2: Highlight Correct Answer (Capture 1 Frame) ---
            const options = element.querySelectorAll("li");
            options.forEach((optionElement) => {
                const option = optionElement.getAttribute('data-answer');
                if (option === question.correctAnswer) {
                    optionElement.style.backgroundColor = "lightgreen";
                    optionElement.style.color = "black";
                }
            });

            const answerDataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
            const answerWebP = await convertToWebP(answerDataUrl);

            // --- PHASE 3: Capture Explanation (10 Seconds) ---
            if (showExplanationInVideo) {
                setIsExplanationView(true);
            }
            await new Promise(r => setTimeout(r, 1000));
            const explanationDataUrl = await toPng(element, { quality: 1, canvasWidth, canvasHeight });
            const explanationWebP = await convertToWebP(explanationDataUrl);

            // Create a Whammy video instance
            const video = new Whammy.Video(10); // 10 FPS

            // MODIFIED: 5 seconds instead of 10
            frames.forEach(frame => {
                for (let i = 0; i < 10; i++) { // Changed from 10 to 5
                    video.add(frame);
                }
            });

            // Add the answer frame for the last 5 seconds
            for (let i = 0; i < 20; i++) {
                video.add(answerWebP);
            }
            if (showExplanationInVideo) {
                // Add Explanation Frame (7 seconds)
                for (let i = 0; i < 50; i++) {
                    video.add(explanationWebP);
                }
            }

            // Compile video
            video.compile(false, (output) => {
                const videoBlob = new Blob([output], { type: "video/webm" });
                const videoUrl = URL.createObjectURL(videoBlob);

                const link = document.createElement("a");
                link.href = videoUrl;
                link.download = `question-${question.id}.webm`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setProgress(100); // Done
                alert("Video downloaded successfully!");
                setIsProcessing(false);
            });

        } catch (error) {
            console.error("Error generating video:", error);
            setProgress(0);
            setIsProcessing(false);
        }
    };

    const [selectedOption, setSelectedOption] = useState(null);

    const handleOptionClick = (questionId, option) => {
        setSelectedOption(option);
    };

    // const getOptionStyle = (selectedOption, correctAnswer, option) => {
    //     if (option === correctAnswer && selectedOption === option) {
    //         return { backgroundColor: 'lightgreen', color: 'black' }; // Correctly selected
    //     }
    //     if (option === selectedOption && option !== correctAnswer) {
    //         return { backgroundColor: 'lightcoral', color: 'black' }; // Incorrectly selected
    //     }
    //     return {}; // Default style
    // };
    //3
    const getOptionStyle = (selectedOption, correctAnswer, option) => {
        const isSelected = selectedOption === option;
        const isCorrect = option === correctAnswer;
        return {
            background: "white",
            color: "#001F3F",
            padding: "12px 20px",
            margin: "10px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            flex: "1 0 40%", // For the 2x2 grid layout
            fontWeight: "bold",
            // fontSize: "14px",
            fontSize: `${optionSize}px`, // Use variable
            // Custom "Leaf" Shape: rounded top-left and bottom-right
            borderRadius: "0px 20px 0px 20px",
            backgroundColor: isSelected ? (isCorrect ? "lightgreen" : "lightcoral") : "none",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
            transition: "transform 0.2s",
            textAlign: "left"
        };
    };
    //BG THEME IMAGE
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setBgImage(URL.createObjectURL(file));
        }
    };

    const blurLayerStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: "blur(5px)", // 25% visual blur
        transform: "scale(1.1)", // Prevents white edges from the blur
        zIndex: -1,
    };

    return (
        <>
            {/* Overlay for modal */}
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(5px)",
                    zIndex: 999,
                }}
            ></div>
            <div
                style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1000,
                    // background: darkMode ? "#222" : "white",
                    background: darkMode ? "rgba(34, 34, 34, 0.9)" : "rgba(255, 255, 255, 0.9)",
                    color: darkMode ? "white" : "black",
                    padding: "20px",
                    borderRadius: "10px",
                    maxWidth: "90%",
                    width: "600px",
                    maxHeight: "90%", // Constrain modal height
                    overflowY: "auto", // Enable vertical scrolling
                }}
            >
                <h3>Generate and Download Video</h3>
                <div style={{
                    position: "absolute",
                    top: "-50%",
                    left: "-50%",
                    width: "200%",
                    height: "200%",
                    background: "linear-gradient(45deg, transparent 45%, rgba(255,255,255,0.3) 50%, transparent 55%)",
                    pointerEvents: "none",
                    zIndex: 1
                }}></div>

                <div
                    id={`share-question-${question.id}`}
                    style={{
                        // background: darkMode ? "#333" : "white",
                        // color: darkMode ? "white" : "black",
                        // border: darkMode ? "2px solid #555" : "2px solid #000",
                        // borderRadius: "10px",
                        // padding: "20px",
                        // textAlign: "center",
                        // margin: "0 auto",
                        //1
                        // background: "#FFD700", // Vibrant Yellow
                        // background: "radial-gradient(circle at 50% 0%, #FFEC8B 0%, #FFD700 50%, #E6B800 100%)",
                        background: bgImage ? "none" : "radial-gradient(circle at 50% 0%, #FFEC8B 0%, #FFD700 50%, #E6B800 100%)",
                        color: "#001F3F", // Deep Navy Blue for text
                        borderRadius: "15px",
                        padding: "40px 20px",
                        textAlign: "center",
                        margin: "0 auto",
                        position: "relative",
                        overflow: "hidden",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                        // border: "4px solid #FFFFFF", // White border makes the yellow pop
                        // boxShadow: "0 20px 50px rgba(0,0,0,0.3), inset 0 0 20px rgba(255,255,255,0.5)",
                    }}

                >
                    {/* Background Image Layer (only shows if bgImage exists) */}
                    {bgImage && <div style={blurLayerStyle}></div>}

                    {countdown !== null && isProcessing && (
                        <div style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "220px",
                            fontWeight: "900",
                            color: "rgba(0, 31, 63, 0.12)", // Translucent Navy
                            zIndex: 1,
                            pointerEvents: "none",
                            fontFamily: "Arial Black"
                        }}>
                            {countdown}
                        </div>
                    )}

                    {/* Dark Overlay to ensure text stays readable on light images */}
                    {/* {bgImage && <div style={{
                        position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
                        background: "rgba(255, 215, 0, 0.3)",
                        zIndex: 1001
                    }}></div>} */}
                    {!isExplanationView ? (
                        <div ref={questionRef} // Attach the ref here
                            style={{
                                marginBottom: "20px",
                                // border: darkMode ? "1px solid #555" : "1px solid #000",
                                border: "1px solid #bb8686",
                                borderRadius: "10px",
                                padding: "20px",
                            }}>

                            {/* <h2 style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "10px"
                        }}>
                            {question.question}
                            <span style={{ fontSize: "16px", fontWeight: "bold" }}> {question?.exam}</span>
                        </h2> */}
                            <div style={{
                                background: "rgba(255, 255, 255, 0.95)", // Clean white background
                                padding: "15px 10px",
                                borderRadius: "15px",
                                marginBottom: "25px",
                                position: "relative",
                                zIndex: 2,
                                // 3D Shadow to make it "float"
                                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
                                border: "1px solid rgba(255, 255, 255, 0.5)",
                            }}>
                                <h2 style={{
                                    // fontSize: "16px",
                                    fontSize: `${questionSize}px`, // Use variable
                                    color: "#001F3F",
                                    margin: 0,
                                    lineHeight: "1.4",
                                    fontWeight: "bold"
                                }}>
                                    {question.question} {question?.exam}
                                </h2>
                            </div>
                            <ul style={{
                                // listStyleType: "none", 
                                // padding: 0 
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                padding: 0,
                                listStyle: "none"
                            }}>
                                {question.options.map((option, index) => (
                                    <li
                                        key={index}
                                        onClick={() => handleOptionClick(question.id, option)}
                                        style={{
                                            padding: "10px",
                                            margin: "5px 0",
                                            cursor: "pointer",
                                            border: darkMode ? "1px solid #666" : "1px solid #ddd",
                                            borderRadius: "5px",
                                            boxShadow: "5px 5px 15px rgba(0,0,0,0.1)",
                                            ...getOptionStyle(selectedOption, question.correctAnswer, option),
                                        }}
                                        data-answer={option}  // Add this data attribute
                                    >
                                        <span style={{
                                            backgroundColor: "#001F3F",
                                            color: "white",
                                            padding: "5px 12px",
                                            marginRight: "15px",
                                            borderRadius: "0 10px 0 10px",
                                            fontSize: "12px",
                                            // fontSize: `${optionSize}px`, // Use variable
                                        }}>
                                            {String.fromCharCode(65 + index)}
                                        </span>
                                        <span></span>
                                        {option}
                                    </li>
                                ))}
                            </ul>
                            {/* <span style={{ fontSize: "12px" }}>Please find the answer at the end.</span> */}
                            <div style={{ marginTop: "10px" }}>
                                <div style={{
                                    width: "100%",
                                    background: darkMode ? "#444" : "#ddd",
                                    borderRadius: "5px",
                                    overflow: "hidden"
                                }}>
                                    <div
                                        style={{
                                            width: `${progress}%`,
                                            height: "10px",
                                            background: "lightgreen",
                                            transition: "width 0.2s ease-in-out",
                                        }}
                                    ></div>
                                </div>
                            </div>

                        </div>
                    ) : (
                        /* --- EXPLANATION VIEW (New Stage) --- */
                        <div style={{
                            width: dimensions.width,   // Use stored width
                            height: dimensions.height, // Use stored height
                            marginBottom: "20px",
                            border: "1px solid #bb8686", // Exact border color from Question View
                            borderRadius: "10px",
                            padding: "20px",
                            position: "relative",
                            zIndex: 2,
                            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
                            boxSizing: "border-box",    // Very important
                        }}>
                            {/* <h3 style={{ color: "#001F3F", marginTop: 0, fontSize: "18px", borderBottom: "2px solid #FFD700", display: "inline-block" }}>Explanation</h3> */}

                            {question.image && (
                                <img
                                    src={question.image}
                                    alt="Explanation"
                                    style={{
                                        // width: "100%",
                                        // height: "auto",
                                        // // maxHeight: "150px",
                                        // objectFit: "contain",
                                        // borderRadius: "10px",
                                        // margin: "10px 0",
                                        // border: "1px solid #ddd",
                                        // background: "rgba(255, 255, 255, 0.95)",
                                        // padding: "15px 10px",
                                        // display: "block",
                                        maxWidth: "100%",
                                        maxHeight: "300px",
                                        borderRadius: "8px",
                                        boxShadow: "rgba(0, 0, 0, 0.7) 0px 2px 6px",
                                        border: "1px solid #ddd",
                                        objectFit: "contain",
                                        background: "rgba(255, 255, 255, 0.95)",
                                        // padding: "4px"

                                    }}
                                />
                            )}

                            <p style={{
                                // fontSize: "14px",
                                fontSize: `${explanationSize}px`, // Use variable
                                margin: "5px",
                                background: "rgba(255, 255, 255, 0.95)",
                                padding: "15px 10px",
                                color: "#001F3F",
                                lineHeight: "1.4",
                                fontWeight: "bold",
                                borderRadius: "15px",
                                whiteSpace: "pre-line"

                            }}>
                                {question.explanation}
                            </p>
                        </div>
                    )}

                    {/* <footer
                        style={{
                            position: "relative",
                            bottom: "10px",
                            background: darkMode ? "#555" : "#f1f1f1",
                            color: darkMode ? "white" : "black",
                            padding: "5px 10px",
                            borderRadius: "5px",
                        }}
                    >
                        <p style={{ fontSize: "14px", margin: 0 }}>© 2024 SSCVIDYA.IN</p>
                    </footer> */}
                    <footer
                        style={{
                            width: "100%",
                            background: "#001F3F", // Deep Navy Blue footer
                            color: "white",
                            padding: "12px 0",
                            position: "absolute",
                            bottom: "0",
                            left: "0",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "0 -4px 10px rgba(0,0,0,0.1)"
                        }}
                    >
                        <p style={{
                            fontSize: "12px",
                            margin: 0,
                            fontWeight: "700",
                            letterSpacing: "2px",
                            textTransform: "uppercase"
                        }}>
                            © 2026 SSCVIDYA.IN
                        </p>
                    </footer>
                </div>

                <button
                    onClick={handleDownloadVideo}
                    className="button"
                    style={{ marginTop: "10px" }}
                    disabled={isProcessing}
                >
                    {isProcessing ? "Processing..." : "Download Video"}
                </button>
                <button
                    onClick={onClose}
                    className="button"
                    style={{ marginTop: "10px", marginLeft: "10px" }}
                >
                    Close
                </button>
                <button
                    className="button"
                    style={{ marginTop: "10px", marginLeft: "10px", position: "relative" }}
                >
                    Upload Theme
                    <label style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        cursor: "pointer"
                    }}>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                            style={{ display: "none" }}
                        />
                    </label>
                </button>
                <div style={{
                    background: darkMode ? "#444" : "#f9f9f9",
                    padding: "15px",
                    borderRadius: "10px",
                    marginTop: "20px",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "10px"
                }}>
                    {/* Question Font Slider */}
                    <div>
                        <label style={{ fontSize: "12px", fontWeight: "bold" }}>Question: {questionSize}px</label>
                        <input
                            type="range" min="12" max="30"
                            value={questionSize}
                            onChange={(e) => setQuestionSize(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    </div>

                    {/* Options Font Slider */}
                    <div>
                        <label style={{ fontSize: "12px", fontWeight: "bold" }}>Options: {optionSize}px</label>
                        <input
                            type="range" min="10" max="25"
                            value={optionSize}
                            onChange={(e) => setOptionSize(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    </div>

                    {/* Explanation Font Slider */}
                    <div>
                        <label style={{ fontSize: "12px", fontWeight: "bold" }}>Explanation: {explanationSize}px</label>
                        <input
                            type="range" min="10" max="25"
                            value={explanationSize}
                            onChange={(e) => setExplanationSize(e.target.value)}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: "flex-start",
                    gap: '10px',
                    marginBottom: '15px'
                }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#555' }}>
                        {isExplanationView ? "View Explanation ON" : "View Explanation OFF"}
                    </span>

                    <div
                        onClick={() => setIsExplanationView(!isExplanationView)}
                        style={{
                            width: "50px",
                            height: "25px",
                            backgroundColor: isExplanationView ? "lightgreen" : "#ccc",
                            borderRadius: "25px",
                            position: "relative",
                            cursor: "pointer",
                            transition: "background-color 0.3s"
                        }}
                    >
                        <div style={{
                            width: "21px",
                            height: "21px",
                            backgroundColor: "white",
                            borderRadius: "50%",
                            position: "absolute",
                            top: "2px",
                            left: isExplanationView ? "26px" : "3px", // Moves the "knob"
                            transition: "left 0.3s",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                        }} />
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: "flex-start",
                    gap: '10px',
                    marginBottom: '15px'
                }}>
                    <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#555' }}>
                        {showExplanationInVideo ? "Explanation ON" : "Explanation OFF"}
                    </span>

                    <div
                        onClick={() => setShowExplanationInVideo(!showExplanationInVideo)}
                        style={{
                            width: "50px",
                            height: "25px",
                            backgroundColor: showExplanationInVideo ? "lightgreen" : "#ccc",
                            borderRadius: "25px",
                            position: "relative",
                            cursor: "pointer",
                            transition: "background-color 0.3s"
                        }}
                    >
                        <div style={{
                            width: "21px",
                            height: "21px",
                            backgroundColor: "white",
                            borderRadius: "50%",
                            position: "absolute",
                            top: "2px",
                            left: showExplanationInVideo ? "26px" : "3px", // Moves the "knob"
                            transition: "left 0.3s",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                        }} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default SharePopupWithVideo;
